// extracted by mini-css-extract-plugin
export default {"input":"input_input__644i2","select":"input_select__ISpi8","wrapper":"input_wrapper__mMkRC","padding":"input_padding__c2T+f","error":"input_error__5ROpx"};